import { useUser } from '@clerk/clerk-react';
import { useQueryClient } from '@tanstack/react-query';
import { PropsWithChildren, useState } from 'react';
import { Outlet } from 'react-router';
import { useAuthedUserContext } from '../hooks/use-authed-user';
import { fetchJson } from '../util/xhr';
import { ClassyLoading } from './ClassyLoading';
import { OnboardingWizard } from './OnboardingWizard';
import { t } from '@lingui/core/macro';

export function OnboardingOutlet() {
  return (
    <OnboardingOutletProvider>
      <Outlet />
    </OnboardingOutletProvider>
  );
}

function OnboardingOutletProvider(props: PropsWithChildren) {
  const client = useQueryClient();
  const auth = useAuthedUserContext();
  const { user } = useUser();
  const [working, setWorking] = useState('');
  if (working) return <ClassyLoading message={working} />;
  if (!auth.onboarding)
    return (
      <OnboardingWizard
        userType={auth.user_type}
        user={user!}
        onFinish={async (data) => {
          // 1. Update profile
          setWorking(t`Updating your personalization information...`);
          const { first_name, last_name, company, role, language_code, company_name, title, job_level, number_of_employees, job_function, industry } = data;
          await fetchJson('api/profile', {
            profile: { first_name, last_name, company, role, language_code, company_name, title, job_level, number_of_employees, job_function, industry },
          });

          // 2. Mark the user as onboarded
          setWorking(t`Recording onboarding...`);
          await fetchJson('api/onboarded');

          // 3. Clean up to trigger refresh of authed user
          setWorking(t`Finishing up...`);
          client.invalidateQueries({
            queryKey: ['authed-user'],
          });
          setWorking('');
        }}
      />
    );
  return <>{props.children}</>;
}
